import { useFormState } from 'react-hook-form'

import Button, { Props as ButtonProps } from '@/components/ui/Button'

type Props = ButtonProps & {
  onlyValidWhenDirty?: boolean
}

export function Submit({
  children,
  onlyValidWhenDirty = false,
  ...rest
}: Props) {
  const { disabled, isSubmitting, isDirty } = useFormState()

  if (disabled) return

  return (
    <Button
      type="submit"
      disabled={onlyValidWhenDirty && !isDirty}
      loading={isSubmitting}
      {...rest}
    >
      {children}
    </Button>
  )
}
